export const TypeAngles = {
    "Apto Tipo D": 0,
    "Apto Tipo E": 10,
    "Apto Tipo F": 10,
    "Apto Tipo G": 0,
    "Classic": 90,
}